import { useTimerStore } from '../../stores/timer-store'
import { cn } from '../../lib/utils'
import type { ExerciseTemplateKind } from '../../types/exercise-template'

const KIND_COLORS: Record<ExerciseTemplateKind, string> = {
  normal: 'bg-blue-500',
  warmup: 'bg-yellow-400',
  dropset: 'bg-pink-500',
  failure: 'bg-red-600',
}

export function TimerHeader() {
  const templates = useTimerStore((s) => s.templates)
  const templateIdx = useTimerStore((s) => s.templateIdx)
  const setIdx = useTimerStore((s) => s.setIdx)

  if (templates.length === 0) return null

  return (
    <div className="flex w-full gap-1">
      {templates.map((tpl, idx) => {
        let pct = 0
        if (idx < templateIdx) pct = 100
        else if (idx === templateIdx) pct = Math.min(100, ((setIdx) / Math.max(1, tpl.sets)) * 100)
        return (
          <div key={tpl.id} className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className={cn('h-full transition-[width] duration-300 ease-out', KIND_COLORS[tpl.kind])}
              style={{ width: `${pct}%` }}
            />
          </div>
        )
      })}
    </div>
  )
}
